import { Component, } from '@angular/core';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {CookieService} from 'angular2-cookie/core';
import { HelperService } from './helper.service';
import { Http, Response } from '@angular/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [HelperService]
})
export class AppComponent {
  title = 'My first angular.This is marvelous';
	user_permissions;
  constructor(private router:Router,private cookie:CookieService,private helper:HelperService,private http:Http){

  	if(cookie.get('auth')=="N"){
      this.router.navigate(["/login"]);
    }
   
  }
  ngOnInit() {
  	

  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts